<template>
  <div>
    <emd-container :title="$t('identification')">
      <template v-slot:content>
        <div class="eu-flex">
          <div class="eu-flex-item eu-basis_12 eu-basis_12_md">
            <div class="emd-form-group">
              <label class="emd-label">{{ $t('linkName') }} <span class="label-optional">({{ $t('optional') }})</span></label>
              <input
                :class="{'_state_error': $v.paymentLinkData.name.$invalid && showFeedbacks.status}"
                :value="paymentLinkData.name"
                @input="changeValue($event, 'name')"
                class="emd-input"
                :placeholder="$t('linkNamePlaceholder')"
              />
              <p class="emd-input-feedback _state_error" v-if="!$v.paymentLinkData.name.maxLength && showFeedbacks.status">
                {{ $t('hint.length', { length: '64' }) }}
              </p>
            </div>
            <div class="emd-form-group">
              <label class="emd-label">{{ $t('orderCode') }} <span class="label-optional">({{ $t('optional') }})</span></label>
              <input
                :class="{'_state_error': $v.orderCode.$invalid && showFeedbacks.status}"
                :value="orderCode"
                @input="setOrderCodeValue($event)"
                class="emd-input"
                :placeholder="$t('orderCodePlaceholder')"
              />
              <p class="emd-input-feedback _state_error" v-if="!$v.orderCode.maxLength && showFeedbacks.status">
                {{ $t('hint.length', { length: '64' }) }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </emd-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EmdContainer from '../../../components/emerald/molecules/EmdContainer.vue'
import { maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'Identification',
  components: {
    EmdContainer
  },
  data () {
    return {
      showError: true
    }
  },
  computed: {
    ...mapGetters(['orderCode', 'paymentLinkData', 'showFeedbacks'])
  },
  methods: {
    ...mapActions(['UPDATE_DATA', 'SET_ORDER_CODE']),
    changeValue (event, attribute) {
      this.UPDATE_DATA({
        value: event.target?.value,
        attribute
      })
      this.$emit('formIsValid', this.$v.$invalid)
    },
    setOrderCodeValue (event) {
      this.SET_ORDER_CODE(event.target?.value)
      this.$emit('formIsValid', this.$v.$invalid)
    }
  },
  validations: {
    paymentLinkData: {
      name: {
        maxLength: maxLength(64)
      }
    },
    orderCode: {
      maxLength: maxLength(64)
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "identification": "Identificação",
    "linkName": "Nome do link",
    "linkNamePlaceholder": "É como você pode buscar o seu link",
    "orderCode": "Código de identificação",
    "orderCodePlaceholder": "Ex.: LP003",
    "optional": "opcional",
    "hint": {
      "length": "Máximo de {length} caracteres"
    }
  },
  "en-US": {
    "identification": "Identification",
    "linkName": "Link name",
    "linkNamePlaceholder": "Is how you can look for your payment link",
    "orderCode": "Código de identificação",
    "orderCodePlaceholder": "Ex.: LP003",
    "optional": "optional",
    "hint": {
      "length": "This field cannot be more than {length} characters"
    }
  }
}
</i18n>
